import React, {useContext,useEffect,useState} from 'react'
import { initMercadoPago, Wallet } from '@mercadopago/sdk-react'
import {Card, CardHeader, CardContent, Typography, Button} from '@mui/material'
import Box from '@mui/material/Box';
import { formularioContext } from '../contextos/FormularioContext'
import Swal from 'sweetalert2';
import {Dialogos} from './Dialogos'
import {useHelper} from '../hooks/useHelper'
import CircularProgress from '@mui/material/CircularProgress';
import {ETMostrarDatosVenta} from './ETMostrarDatosVenta'
import {ETMostrarDatosVentaCont} from './ETMostrarDatosVentaCont'

export const ETPagando = ({abrir,
                    procesar,
                    cancelar,
                    item_a_pagar,
                    venta,
                    generarPreferencia,
                    eventoSeleccionado,
                    descripcionProvincia,
                    datosMinistroUad})=>{
    const [preferencia,setPreferencia] = React.useState(null)
    const [loading,setLoading] = React.useState(false)
    const {formatearMontoMoneda}= useHelper()
    const {grupo,infoMinistro} = useContext(formularioContext)

    initMercadoPago('APP_USR-8c9b233b-d2c0-44a2-b31e-e3863404a3b1');

    useEffect(()=>{
        setLoading(true);
        setPreferencia(null);
        if(item_a_pagar){
            pagar();
        }
    },[item_a_pagar])

    const pagar = async ()=>{
       const preferencia_de_api = await generarPreferencia(item_a_pagar?.id_evento_valor,item_a_pagar?.id_evento);
       if(preferencia_de_api){
        setTimeout(() => {
           setPreferencia(preferencia_de_api);
        }, 1000);
       }else{
        cancelar()
       }
      
}

    const onReady = ()=>{
            setLoading(false);
    }

    const onError = (e)=>{
        console.log(e)
        alert('Se produjo un error al inicializar el pago. Vuelva a intentarlo más tarde.')
    }
    return <Box>
                        <ETMostrarDatosVentaCont
                            venta={venta} 
                            descripcionProvincia={descripcionProvincia} 
                            datosMinistroUad={datosMinistroUad}
                            item_a_pagar={item_a_pagar}
                        />
                      {loading && <CircularProgress sx={{marginRight:'auto',marginLeft:'auto',display:'block',marginTop:'15px'}} color="primary" /> }
                      <div style={{display:loading ?'none':'block'}}>
                                    {(preferencia?.id) && <Box 
                                        sx={{
                                            display: 'flex',
                                            flexDirection: 'column',  // Stack vertical
                                            alignItems: 'center',
                                            mt: 2,
                                        }}
                                        >
                                        <Box
                                            id="wallet-wrapper"
                                            sx={{
                                            width: '100%',             // forzamos que Wallet use todo el ancho posible dentro del contenedor
                                            maxWidth: 400,             // opcional: límite de ancho para que no se estire mucho
                                            }}
                                        >
                                            <Wallet
                                            onReady={onReady}
                                            onError={onError}
                                            initialization={{
                                                preferenceId: preferencia?.id,
                                                redirectMode: 'self'
                                            }}
                                            locale="es-AR"
                                            />
                                        </Box>

                                        <Button
                                            variant="outlined"
                                            onClick={cancelar}
                                            fullWidth
                                            sx={{
                                            mt: 2,
                                            maxWidth: 400,              
                                            textTransform: 'none',
                                            }}
                                            title="Cancelar la compra"
                                        >
                                            Cancelar
                                        </Button>
                                        </Box>}
                      </div>
    </Box>
}

